<template>

    <!-- ===== Page-Content ===== -->
    <div class="page-wrapper" style="margin-top: 65px">
        <!-- ===== Page-Container ===== -->
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
        ></loading>
        <div class="container-fluid">
            <table>
            </table>
            <!-- <div class="row colorbox-group-widget" v-if="user_type_id==2 || user_type_id==6"> -->
                <div class="white-box">
                
                <div class="row">
                    <h3>Instructions</h3><hr><br><br>
                    <ul>
                        <li>Security Guards working in Maharastra need to take this survey.</li>
                        <li>Mobile number verification will be done using OTP. Please make sure you have your mobile with you</li>
                       <li> <b>Following documents need to be uploaded while taking the survey -</b>
                           <ol>
                               <li>Aadhar Card</li>
                               <li>Photo of the Guard</li>
                               <li>Employment Proof (Latest ID Card or Payslip or Attendence Record etc.)</li>
                           </ol>
                       </li>
                       <li>Please provide corrent information</li>
                    </ul><br>
                     <center><b-button variant="primary" v-on:click="link_page">Submit</b-button></center>
                </div>                
                </div>
                <div class="row colorbox-group-widget" v-if="user_type_id==2 || user_type_id==6">
                </div>  
           </div>
        <!-- ===== Page-Container-End ===== -->
        <footer class="footer t-a-c">
            
        </footer>
    </div>
    <!-- ===== Page-Content-End ===== -->
    
</template>
<style>
    .white-box{ border: none;
                -webkit-box-shadow: 2px 9px 13px -6px rgba(0,0,0,0.75);
                -moz-box-shadow: 2px 9px 13px -6px rgba(0,0,0,0.75);
                box-shadow: 2px 9px 13px -6px rgba(0,0,0,0.75);}
    .white-box a{ color:#fff;}
</style>

<script>

export default {
    name: 'DashboardClean',
    data() {
    return {
      contentOnly: false,
      role:"",
      user_type_id:"",
      load:0,
      mob: '',
      otp: '',
      isLoading: false,
      fullPage: true,
    }

      
  },
  methods:{      
    loadOnce:function(){
      if(this.load==0)
      {
        location.reload(1);
      }
    },
    link_page()
    {
       // alert("push");
        this.$router.push({path: '/otp_verify'})
        //this.$router.push(otp_verify);
    },
 
  },

  created() {
     
 
  },
    complete(){
        location.reload();
    },


    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/GuardSurvey/Instructions.vue